import { useEffect } from 'react'
import { shallow } from 'zustand/shallow'
import { useLocation } from 'react-router-dom'
import { Paper, Grid } from '@mui/material'
import { useNetwork, useAccount } from 'wagmi'

import { useChainAndNetwork, chainType } from 'src/store/chainAndNetwork'
import { useAuthDispatch } from 'src/contexts/authContext'
import { evmNetworkIds, evmNetworkIdsType } from 'src/util/chainIds'

const supportedChains: chainType[] = ['bnb', 'ethereum', 'polygon', 'multiversx']

const ChainOptions = () => {
  const {
    chain: selectedChain,
    network,
    setChain,
    setNetwork,
  } = useChainAndNetwork(
    (state) => ({
      chain: state.chain,
      network: state.network,
      setChain: state.setChain,
      setNetwork: state.setNetwork,
    }),
    shallow,
  )

  const isMobile = window.innerWidth < 768
  const dispatchAction = useAuthDispatch()

  const { chain } = useNetwork()
  const walletConnectAccount = useAccount()

  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)
  const queryChain = queryParams.get('chain')
  const urlPathName = location.pathname

  const handleSelectChain = (chainPayload: string) => {
    // Restrict createSC page to only EVM
    if (
      (urlPathName.includes('/create-vesting-contract') ||
        urlPathName.includes('create-staking-contract')) &&
      chainPayload === 'multiversx'
    ) {
      return
    }

    setChain(chainPayload as chainType)

    if (chainPayload !== 'multiversx' && network !== 'testnet') {
      setNetwork('testnet')
    }

    const walletConnectChainIdMismatch =
      walletConnectAccount?.isConnected &&
      chain?.id !== evmNetworkIds[chainPayload.toUpperCase() as keyof evmNetworkIdsType]?.testnet

    if (chainPayload !== 'multiversx' && walletConnectChainIdMismatch) {
      dispatchAction({
        type: 'SWITCHNETWORKMODAL',
        payload: true,
      })
    }
  }

  useEffect(() => {
    if (queryChain && supportedChains.includes(queryChain as chainType)) {
      handleSelectChain(queryChain)
    }
  }, [queryChain])

  useEffect(() => {
    if (
      (urlPathName.includes('/create-vesting-contract') ||
        urlPathName.includes('create-staking-contract')) &&
      selectedChain === 'multiversx'
    ) {
      handleSelectChain('ethereum')
    }
  }, [urlPathName])

  return (
    <Grid
      container
      sx={{
        display: 'flex',
        flexDirection: isMobile ? 'column' : 'row',
        // justifyContent: "space-between",
        alignItems: 'flex-start',
        gap: '20px',
      }}>
      {supportedChains.map((item) => {
        return (
          <Grid item key={item} sx={{ display: 'flex', flexDirection: 'column' }}>
            <Paper
              onClick={() => handleSelectChain(item)}
              variant="outlined"
              sx={{
                display: 'flex',
                flex: '0 0 auto',
                minWidth: '0',
                maxWidth: '200px',
                width: '160px',
                textAlign: 'center',
                justifyContent: isMobile ? 'flex-start' : 'center',
                padding: '10px',
                elevation: 0,
                cursor:
                  (urlPathName.includes('/create-staking-contract') ||
                    urlPathName.includes('/create-vesting-contract')) &&
                  item === 'multiversx'
                    ? 'default'
                    : 'pointer',
                backgroundColor: 'transparent',
                fontSize: '24px',
                fontWeight: '500',
                borderRadius: '8px',
                borderColor: selectedChain === item ? '#2AEAFA' : 'rgba(255, 255, 255, 0.25)',
                gap: '15px',
                color:
                  (urlPathName.includes('/create-staking-contract') ||
                    urlPathName.includes('/create-vesting-contract')) &&
                  item === 'multiversx'
                    ? 'rgba(255, 255, 255, 0.25)'
                    : '#ffffff',
              }}>
              <span className={`icon-${item.toLowerCase()}`} />
              <span className="text-lg">{item}</span>
            </Paper>
          </Grid>
        )
      })}
    </Grid>
  )
}

export default ChainOptions
